<template>
  <div id="scheduleDetailList">
    <!-- <CCard class="content-fade-in mt-3p5">

    </CCard> -->
    <CCard class="content-fade-in mt-3p5">
      <CCardHeader>
        <h6>Thông tin lịch phát</h6>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol xs="12" sm="12" md="6" xl="6">
            <BaseInput :options="scheduleData.dateRangeInput.options" :data="scheduleData.dateRangeInput.data"/>
          </CCol>
          <CCol xs="12" sm="12" md="3" xl="3">
            <div class="form-group">
              <label for=""> </label>
              <div class="mb-1">Ngày tạo: <span class="info-detail">{{
                  $helper.formatDate(scheduleData.createDate)
                }}</span></div>
              <div>Người tạo: <span class="info-detail">{{
                  scheduleData.createUserName + ' - ' +
                  scheduleData.locationName
                }}</span></div>
            </div>
          </CCol>
          <CCol xs="12" sm="12" md="3" xl="3">
            <div class="form-group">
              <label for=""> </label>
              <div class="mb-1">
                Kiểu lịch:
                <span class="badge badge-light" v-if="scheduleData.mode == 0">Khung giờ cố định</span>
                <span class="badge badge-light" style="font-weight:bold" v-else-if="scheduleData.mode == 1">Theo lịch
                  thiết lập
                  ({{
                    scheduleData.modeSchedule == 0 ? 'Ngày trong tuần' : 'Ngày trong tháng'
                  }})</span>
                <span class="badge badge-danger" v-else-if="scheduleData.mode == 2">Khẩn cấp</span>
              </div>
              <div>Nội dung: <span class="info-detail">{{ scheduleData.title }}</span></div>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="text-right">
            <CButton color="secondary" @click="$router.go(-1)"><i class="fa fa-reply"></i> Quay lại</CButton>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardHeader>
        <h6>Thông tin chi tiết lịch phát</h6>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
            <label>Thao tác</label>
            <div class="dropdown btn-group" style="height: 36px;">
              <button class="btn">
                <div class="group-checkbox">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                           @change="changeSelectAll" id="selectedAll"/>
                    <label class="custom-control-label" for="selectedAll"></label>
                  </div>
                </div>
              </button>
              <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
                      aria-expanded="false" aria-haspopup="true"></button>
              <div class="dropdown-menu">
                <button :disabled="actionData.model.listScheduleDetailSelectedId.length === 0" class="dropdown-item"
                        @click="setupSelectOneAction('update_active_list', null, true)">
                  <CIcon name="cil-check" color="success" class="mr-2"/>
                  Kích hoạt tất cả
                </button>
                <button :disabled="actionData.model.listScheduleDetailSelectedId.length === 0" class="dropdown-item"
                        @click="setupSelectOneAction('update_active_list', null, false)">
                  <CIcon name="cil-x-circle" color="danger" class="mr-2"/>
                  Hủy tất cả
                </button>
              </div>
            </div>
          </CCol>
          <CCol xs="12" sm="4" md="3" lg="3" xl="2">
            <div class="form-group">
              <label for="datepicker">Từ ngày - đến ngày</label>
              <DatePicker locale="vi" id="datepicker" v-model="dateRange"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                          :min-date="minDate" :max-date="maxDate" is-range class="datepicker"
                          :popover="{ visibility: 'click' }">
                <template v-slot="{ inputValue, inputEvents }">
                  <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                         class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly/>
                </template>
              </DatePicker>
            </div>
          </CCol>
          <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol> -->
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
                         class="btn-action-primary" @click="loadDataMainTable(true)">
                  <i class="fa fa-refresh"></i>&nbsp; Tải lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
                   @row-click="rowClickTable($event)" ref="mainTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                       v-model="actionData.model.listScheduleDetailSelectedId" :value="item.id" :id="item.id"/>
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #type="{ item }">
            <td>
              <span v-if="item.type == 0" class="badge badge-light">Văn bản</span>
              <span v-else class="badge badge-info">Media</span>
            </td>
          </template>
          <!-- <template #playDate="{ item }">
            <td v-if="item.playDate != null">
              {{ $helper.formatDateDDMMYYYY(item.playDate) }}
            </td>
            <td v-if="item.playDate == null"></td>
          </template> -->
          <template #duration="{ item }">
            <td v-if="item.startTime != null && item.endTime != null">
              {{ $helper.calculatorDuration(item.startTime, item.endTime) }}
            </td>
            <td v-else></td>
          </template>
          <template #startTime="{ item }">
            <td v-if="item.startTime != null">
              <!-- {{ item.startTime[0] + ":" + item.startTime[1]}} -->
              {{ $helper.formatDateDDMMYYYYHHMM(item.startTime) }}
              <!-- {{item.startTime}} -->
            </td>
            <td v-if="item.startTime == null"></td>
          </template>
          <template #endTime="{ item }">
            <td v-if="item.endTime != null">
              <!-- {{ item.endTime[0] + ":" + item.endTime[1]}} -->
              {{ $helper.formatDateDDMMYYYYHHMM(item.endTime) }}
              <!-- {{item.endTime}} -->
            </td>
            <td v-if="item.endTime == null"></td>
          </template>
          <template #locationName="{ item }">
            <td>
              <span class="badge badge-light">{{ item.locationName }}</span>
            </td>
          </template>
          <template #devices="{ item, index }">
            <td>
              <template v-for="(each) in viewDevice(item)">
                <span class="badge badge-light mr-2">
                  {{ each }}
                </span><br/>
              </template>
              <span class="badge badge-light"
                    v-if="$helper.convertStringToArray(item.devices, ';\n').length > maxDisplayDeviceTable"
                    v-c-tooltip.hover="{ content: `${item.devices}`, placement: 'right' }">...</span>
            </td>
          </template>
          <template #active="{ item }">
            <td>
              <span v-if="item.active == 1" class="dot-custom dot-success">
                Hoạt động
                <BaseSwitch v-if="item.status === 0 || item.status === 1" class="mx-1" color="success" checked
                            variant="3d" v-c-tooltip.hover="'Hủy'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.playDate, item.startTime, item.endTime)"/>
              </span>
              <span v-else class="dot-custom dot-danger">
                Đã hủy
                <BaseSwitch v-if="item.startTime >= new Date()" class="mx-1" color="danger" variant="3d"
                            v-c-tooltip.hover="'Kích hoạt'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.playDate, item.startTime, item.endTime)"/>
              </span>
            </td>
          </template>
          <template #status="{ item }">
            <td>
              <span v-if="item.status == ScheduleDetailStatus.PENDING" class="badge badge-info">Chờ phát</span>
              <span v-else-if="item.status == ScheduleDetailStatus.PLAYING" class="badge badge-warning">Đang phát</span>
              <span v-else-if="item.status == ScheduleDetailStatus.BROADCAST" class="badge badge-success">Đã phát</span>
              <span v-else-if="item.status == ScheduleDetailStatus.ERROR" class="badge badge-danger">Phát lỗi</span>
              <span v-else-if="item.status == ScheduleDetailStatus.CANCEL" class="badge badge-danger">Đã hủy</span>
              <span v-else-if="item.status == ScheduleDetailStatus.COINCIDENT" class="badge badge-danger">Bị
                trùng</span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="item.status === 0 || item.status === 1 || item.status === 5" color="info"
                         variant="outline" v-c-tooltip.hover="{ content: 'Cập nhật thời gian' }" square size="sm"
                         @click="updateData(item.id, item.playDate, item.startTime, item.endTime, item.locationCode, item.status)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton v-if="item.status === 0 || item.status === 1" color="warning" variant="outline"
                         v-c-tooltip.hover="{ content: 'Cập nhật thiết bị' }" square size="sm"
                         @click="updateDevices(item.id, item.locationCode, item.status)">
                  <CIcon name="cil-bullhorn"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal title="Cập nhật lịch phát" :show.sync="isShowModelUpdate" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" sm="12" md="12" xl="12">
          <div class="form-group">
            <label for="datepicker">Ngày phát
              <span class="required">*</span></label>
            <br/>
            <DatePicker id="playDate" locale="vi" v-model="dataDetail.playDate.data.model"
                        :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" class="datepicker" :min-date="minDate"
                        :max-date="maxDate" :popover="{ visibility: 'click' }">
              <template v-slot="{ inputValue, inputEvents }">
                <input :value="inputValue" v-on="inputEvents"
                       class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly/>
              </template>
            </DatePicker>
          </div>
        </CCol>
        <CCol xs="12" sm="6" md="6" xl="6">
          <div class="form-group">
            <label for="datepicker">Phát từ giờ
              <span class="required">*</span></label>
            <br/>
            <!--            :style="generateStyleFromTime() ? 'pointer-events: none;background:#2221211a' : ''"-->
            <DatePicker id="startTime" mode="time" v-model="dataDetail.startTime.data.model"
                        :masks="{ input: 'HH:MM', data: 'HH:MM' }" :popover="{ visibility: 'click' }" is24hr>
            </DatePicker>
          </div>
        </CCol>
        <CCol xs="12" sm="6" md="6" xl="6">
          <div class="form-group">
            <label for="datepicker">Đến giờ
              <span class="required">*</span></label>
            <br/>
            <DatePicker id="endTime" mode="time" v-model="dataDetail.endTime.data.model"
                        :popover="{ visibility: 'click' }" :masks="{ input: 'HH:MM', data: 'HH:MM' }" is24hr>
            </DatePicker>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModelUpdate = false"><i class="fa fa-times"></i>
          Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdate()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
      <BaseFormLoading :loading="loadingUpdate.value"></BaseFormLoading>
    </CModal>

    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          với các thiết bị:
          <span v-for="i of exist.devices">
            <br/>
            {{ '- ' + i }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="reloadPage(exist.id)"><i class="fa fa-eye"></i> Xem lịch
          đã tồn tại
        </button>
      </template>
    </CModal>

    <CModal class="updateDevice" size="xl" title="Cập nhật thiết bị" :show.sync="isShowModelDevicesUpdate"
            :closeOnBackdrop="false">
      <CRow>
        <CCol xs="12" sm="5" md="5" xl="5">
          <h6>Thiết bị của địa bàn</h6>
          <BaseTable :options="mainDevicesTable.options" :slots="mainDevicesTable.slots"
                     :dataSource="mainDevicesTable.dataSource" @row-click="rowClickTableAddDevices($event)"
                     ref="mainDevicesTable">
            <template #checkbox="{ item }">
              <td class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="dataDetailDevice.lstDevicesAddSelected"
                         :value="item.deviceId" :id="item.deviceId"/>
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </td>
            </template>
            <template #index="{ index }">
              <td>{{ $refs.mainDevicesTable.getTotalElementByPage + index }}</td>
            </template>
            <!-- <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="danger" variant="outline" v-c-tooltip.hover="'Xóa thiết bị'" square size="sm"
                  @click="deleteDetailDevice(item.id)">
                  <CIcon name="cil-trash" style="danger" />
                </CButton>
              </div>
            </td>
          </template> -->
          </BaseTable>
        </CCol>

        <CCol xs="12" sm="2" md="2" xl="2" style="display: inline-flex; justify-content: center; align-items: center;">
          <CRow>
            <CCol xs="12" sm="12" md="12" xl="12" class="text-center mb-4">
              <CButton color="info" variant="outline" v-c-tooltip.hover="'Thêm thiết bị'" @click="addDetailDevice()">
                <CIcon name="cil-arrow-thick-right" style="info"/>
              </CButton>
            </CCol>
            <template v-if="dataDetailDevice.status == 0">
              <div style="width: 100%;border: 1px solid rgba(128,128,128,0.16);" class=" mb-3"></div>
              <CCol xs="12" sm="12" md="12" xl="12" class="text-center mb-3">
                <CButton color="danger" variant="outline" v-c-tooltip.hover="'Xóa thiết bị'"
                         @click="deleteDetailDevice()">
                  <CIcon name="cil-arrow-thick-left" style="danger"/>
                </CButton>
              </CCol>
            </template>
          </CRow>
        </CCol>

        <CCol xs="12" sm="5" md="5" xl="5">
          <h6>Thiết bị phát của địa bàn</h6>
          <BaseTable :options="mainDevicesScheduleTable.options" :slots="mainDevicesScheduleTable.slots"
                     :dataSource="mainDevicesScheduleTable.dataSource" @row-click="rowClickTableRemoveDevices($event)"
                     ref="mainDevicesScheduleTable">
            <template #checkbox="{ item }">
              <td class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                         v-model="dataDetailDevice.lstDevicesRemoveSelected" :value="item.id" :id="item.id"/>
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </td>
            </template>
            <template #index="{ index }">
              <td>{{ $refs.mainDevicesScheduleTable.getTotalElementByPage + index }}</td>
            </template>
            <!-- <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="danger" variant="outline" v-c-tooltip.hover="'Xóa thiết bị'" square size="sm"
                  @click="deleteDetailDevice(item.id)">
                  <CIcon name="cil-trash" style="danger" />
                </CButton>
              </div>
            </td>
          </template> -->
          </BaseTable>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModelDevicesUpdate = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
      </template>
      <BaseFormLoading :loading="dataDetailDevice.loading.value"></BaseFormLoading>
    </CModal>

    <CModal title="Cảnh báo" :show.sync="scheduleData.isParent" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          <span>
            Đây là bản tin phát thanh được đặt lịch dưới dạng khẩn cấp, thao tác bởi người dùng cấp trên - {{
              scheduleData.locationName
            }}.
            Bạn có chắc chắn muốn chỉnh sửa lịch phát này không?
          </span>
          <br/>
          <span style="color: #ff0303; font-weight: bold;">
              (Nếu thực hiện chỉnh sửa, người dùng sẽ chịu hoàn toàn trách nhiệm cho thao tác này)
            </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)"><i
          class="fa fa-times"></i> Quay lại trang trước
        </button>
        <button type="button" class="btn btn-primary" @click="scheduleData.isParent = false">
          <i class="fa fa-check"></i> Đã hiểu
        </button>
      </template>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import {ScheduleDetailStatus} from "../../constant";

export default {
  name: "ScheduleDetailList",
  components: {
    BaseFormLoading,
    BaseTable,
    BaseInput,
    DatePicker,
    ModalConfirm,
    Multiselect,
    BaseSwitch,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    let actionTypeMapping = new Map();

    actionTypeMapping.set("update_active_list", {
      url: "/schedule-detail/update-active-list",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.active == false ? "hủy toàn bộ lịch đã chọn" : "kích hoạt toàn bộ lịch đã chọn", 'từ ngày'
          , that.$helper.formatDateDDMMYYYY(that.actionData.model.fromDate) + ' đến ngày '
          + that.$helper.formatDateDDMMYYYY(that.actionData.model.toDate))
      },
      // isJsonContentType: false,
      dataSubmit: function () {
        return {
          scheduleId: that.actionData.model.scheduleId,
          active: that.actionData.model.active == false ? 0 : 1,
          selectedAll: that.actionData.model.selectedAll ? 1 : 0,
          listScheduleDetailSelectedId: that.actionData.model.listScheduleDetailSelectedId
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({message: that.actionData.model.active == false ? "Hủy lịch thành công" : "Kích hoạt lịch thành công"});
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });

    actionTypeMapping.set("update_active", {
      url: "/schedule-detail/update-active",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.active == true ? "hủy" : "kích hoạt", 'lịch ngày'
          , that.$helper.formatDateDDMMYYYY(that.actionData.model.playDate) + ' khung giờ '
          + that.$helper.formatHHMM(that.actionData.model.startTime) + '-'
          + that.$helper.formatHHMM(that.actionData.model.endTime));
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({message: that.actionData.model.active == true ? "Hủy lịch thành công" : "Kích hoạt lịch thành công"});
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });

    return {
      loading: {value: false},
      loadingUpdate: {value: false},
      maxDisplayDeviceTable: 5,
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      ScheduleDetailStatus: ScheduleDetailStatus,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          active: null,
          startTime: null,
          endTime: null,
          playDate: null,
          scheduleDetailSelectedId: null,
          listScheduleDetailSelectedId: [],
          fromDate: null,
          toDate: null,
          scheduleId: null
        }
      },
      isShowModelUpdate: false,
      isShowModelDevicesUpdate: false,
      isSelectedAllDevices: false,
      minDate: today,
      maxDate: today,
      scheduleData: {
        dateRangeInput: {
          options: {
            label: "Từ ngày - đến ngày",
            readonly: true
          },
          data: {
            name: "dateRangeScheduleDetail",
            model: ""
          }
        },
        createDate: '',
        createUserName: '',
        mode: '',
        modeSchedule: '',
        locationName: '',
        title: '',
        isParent: false
      },
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false
      },
      dataDetail: {
        id: null,
        playDate: {
          options: {
            label: "Ngày phát",
            placeholder: "Ngày phát"
          },
          data: {
            name: "playDate",
            model: "",
            updateCallback: function () {
              that.submitUpdate();
            }
          }
        },
        locationCode: {
          data: {
            name: "locationCode",
            model: "",
          }
        },
        startTime: {
          options: {
            label: "Phát từ giờ",
            placeholder: "Phát từ giờ"
          },
          data: {
            name: "startTime",
            model: "",
            updateCallback: function () {
              that.submitUpdate();
            }
          }
        },
        endTime: {
          options: {
            label: "Đến giờ",
            placeholder: "Đến giờ"
          },
          data: {
            name: "endTime",
            model: "",
            updateCallback: function () {
              that.submitUpdate();
            }
          }
        }
      },
      dataDetailDevice: {
        lstDevicesAddSelected: [],
        lstDevicesRemoveSelected: [],
        loading: {value: false}
      },
      dateRange: {
        start: new Date(),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: true,
          disabled: true
        },
        data: {
          name: "wardCode",
          model: '',
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#", sorter: false, filter: false},
            // {key: "index", label: "STT"},
            // {key: "playDate", label: "Ngày phát"},
            {key: "startTime", label: "Phát từ giờ"},
            {key: "endTime", label: "Đến giờ"},
            {key: "duration", label: "Thời lượng"},
            {key: "locationName", label: "Địa bàn thiết bị"},
            {key: "devices", label: "Thiết bị phát"},
            {key: "status", label: "Trạng thái phát", _style: "width:5%"},
            {key: "active", label: "Trạng thái kích hoạt", _style: "width:10%"},
            {key: "action", label: "Thao tác", _style: "width:8%", sorter: false, filter: false}
          ],
          slots: [
            "checkbox", "index", "startTime", "endTime", "active", "status", "action", "locationName", "devices", "duration"
          ],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          pageSize: 20,
          itemsPerPageSelect: {label: ' ', values: [15, 20, 50], external: true},
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
          lazyLoad: false
        },
        dataSource: {
          url: "/schedule-detail/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            params.scheduleId = that.$route.params.id;
            params.locationCode = that.locationCode.data.model;
            return params;
          },
          response: function (dataResponse) {
            // if(that.actionData.model.listScheduleDetailSelectedId.length > 0){
            that.actionData.model.listScheduleDetailSelectedId = [];
            // }
            return dataResponse.data;
          },
        },
      },
      mainDevicesTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#", sorter: false, filter: false},
            {key: "index", label: "STT"},
            {key: "deviceCode", label: "Mã thiết bị"},
            {key: "deviceDescription", label: "Mô tả", _style: "width:30%"},
            // { key: "action", label: "Thao tác", _style: "width:5%", sorter: false, filter: false }
          ],
          slots: [
            "checkbox", "index"
          ],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          pageSize: 10,
          // itemsPerPageSelect: { label: ' ', values: [15, 20, 50], external: true },
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
          lazyLoad: false
        },
        dataSource: {
          url: "/schedule-detail-device/get-devices-by-location",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.scheduleDetailId = that.dataDetailDevice.scheduleDetailId;
            params.locationCode = that.dataDetailDevice.locationCode;
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
      mainDevicesScheduleTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#", sorter: false, filter: false},
            {key: "index", label: "STT"},
            {key: "deviceCode", label: "Mã thiết bị"},
            {key: "deviceDescription", label: "Mô tả", _style: "width:30%"},
            // { key: "action", label: "Thao tác", _style: "width:5%", sorter: false, filter: false }
          ],
          slots: [
            "checkbox", "index"
          ],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          pageSize: 10,
          // itemsPerPageSelect: { label: ' ', values: [15, 20, 50], external: true },
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
          lazyLoad: false
        },
        dataSource: {
          url: "/schedule-detail-device/getDevicesPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.scheduleDetailId = that.dataDetailDevice.scheduleDetailId;
            params.locationCode = that.dataDetailDevice.locationCode;
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
      isFirstLoad: true
    };
  },
  methods: {
    rowClickTable(value) {
      let targetClick = value.event.target;
      if ((value.column == 'action' && ($(targetClick).is("button") || $(targetClick).is("path") || $(targetClick).is("svg")))
        || (value.column == 'active' && $(targetClick).is("span.c-switch-slider"))) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listScheduleDetailSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listScheduleDetailSelectedId.indexOf(value.item.id)
          if (index > -1) {
            this.actionData.model.listScheduleDetailSelectedId.splice(index, 1);
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listScheduleDetailSelectedId.push(value.item.id);
        }
      }
    },
    generateStyleFromTime() {
      if (this.dataDetail.startTime.data.model <= new Date() && (this.dataDetail.status != 5)) {
        return true;
      }
      return false;
    },
    reloadPage(id) {
      let that = this;
      that.$router.replace({params: {id: id}});
      that.isShowModelUpdate = false;
      that.exist.isShowModelExist = false;
      that.loadSchedule();
      that.loadDataMainTable();
    },
    updateData(id, playDate, startTime, endTime, locationCode, status) {
      let that = this;
      that.isShowModelUpdate = true;
      that.dataDetail.id = id;
      that.dataDetail.playDate.data.model = playDate;
      that.dataDetail.locationCode.data.model = locationCode;
      that.dataDetail.startTime.data.model = startTime;
      that.dataDetail.endTime.data.model = endTime;
      that.dataDetail.status = status;
    },
    updateDevices(id, locationCode, status) {
      let that = this;
      that.dataDetailDevice.lstDevicesAddSelected = [];
      that.dataDetailDevice.lstDevicesRemoveSelected = [];
      that.dataDetailDevice.scheduleDetailId = id;
      that.dataDetailDevice.locationCode = locationCode;
      that.dataDetailDevice.status = status;
      that.isShowModelDevicesUpdate = true;
      that.loadDataMainDevicesTable();
      that.loadDataMainDevicesScheduleTable();
    },
    rowClickTableAddDevices(value) {
      let that = this;
      let targetClick = value.event.target;
      if (value.column == 'action' && ($(targetClick).is("button") || $(targetClick).is("path") || $(targetClick).is("svg"))) {
        return;
      }
      if (value && value.item && value.item.deviceId) {
        if (that.dataDetailDevice.lstDevicesAddSelected.includes(value.item.deviceId)) {
          const index = that.dataDetailDevice.lstDevicesAddSelected.indexOf(value.item.deviceId)
          if (index > -1) {
            that.dataDetailDevice.lstDevicesAddSelected.splice(index, 1);
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          that.dataDetailDevice.lstDevicesAddSelected.push(value.item.deviceId);
        }
      }
    },
    rowClickTableRemoveDevices(value) {
      let that = this;
      let targetClick = value.event.target;
      if (value.column == 'action' && ($(targetClick).is("button") || $(targetClick).is("path") || $(targetClick).is("svg"))) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (that.dataDetailDevice.lstDevicesRemoveSelected.includes(value.item.id)) {
          const index = that.dataDetailDevice.lstDevicesRemoveSelected.indexOf(value.item.id)
          if (index > -1) {
            that.dataDetailDevice.lstDevicesRemoveSelected.splice(index, 1);
            value.item._classes = 'inactive';
          }
        } else {
          that.dataDetailDevice.lstDevicesRemoveSelected.push(value.item.id);
          value.item._classes = 'active';
        }
      }
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listScheduleDetailSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listScheduleDetailSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listScheduleDetailSelectedId = [];
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    loadDataMainDevicesTable: function (isUpdateFilter) {
      this.$refs.mainDevicesTable.loadData(true, true);
    },
    loadDataMainDevicesScheduleTable: function (isUpdateFilter) {
      this.$refs.mainDevicesScheduleTable.loadData(true, isUpdateFilter);
    },
    loadSchedule: function () {
      let that = this;
      that.loading.value = true;
      that.$helper.loadDataSource({
        url: "/schedule/find-by-id",
        dataSubmit: function () {
          return {id: that.$route.params.id}
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let data = response.data.data;
            var startDate = new Date(data.fromDate);
            var endDate = new Date(data.toDate);

            that.dateRange = {
              start: startDate,
              end: endDate
            }
            that.isFirstLoad = false;
            //
            // that.dateRange.start = startDate;
            // that.dateRange.end = endDate;
            // that.loadDataMainTable();


            that.minDate = startDate;
            that.maxDate = endDate;
            that.scheduleData.startDate = startDate;
            that.scheduleData.endDate = endDate;
            // that.scheduleData.deviceInput.data.model = response.data.data.lstDevice;
            that.scheduleData.dateRangeInput.data.model = that.$helper.formatDateDDMMYYYY(startDate) + ' - ' + that.$helper.formatDateDDMMYYYY(endDate);
            that.scheduleData.createDate = data.createDate;
            that.scheduleData.createUserName = data.createUserName;
            that.scheduleData.mode = data.mode;
            that.scheduleData.modeSchedule = data.modeSchedule;
            that.scheduleData.locationName = data.locationName;
            that.scheduleData.title = data.title;
            that.scheduleData.isParent = data.isParent;
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitUpdate: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loadingUpdate,
        url: "/schedule-detail/update",
        dataSubmit: function () {
          return {
            id: that.dataDetail.id,
            playDate: that.dataDetail.playDate.data.model,
            locationCode: that.dataDetail.locationCode.data.model,
            startTime: that.$helper.formatHHMM(that.dataDetail.startTime.data.model),
            endTime: that.$helper.formatHHMM(that.dataDetail.endTime.data.model),
          }
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            if (response.data.data.id) {
              that.exist.id = response.data.data.id;
              that.exist.msg = response.data.data.msg;
              that.exist.startTime = response.data.data.startTime;
              that.exist.endTime = response.data.data.endTime;
              that.exist.playDate = response.data.data.playDate;
              that.exist.devices = response.data.data.devices;
              that.exist.isShowModelExist = true;
            } else {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
              that.$helper.setupErrorModel(response.data.data, that.$data);
            }
          } else {
            that.showSuccessMsg({message: "Cập nhật lịch phát thành công"});
            that.loadDataMainTable();
            that.isShowModelUpdate = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    setupSelectOneAction: function (actionTypeKey, id, active, playDate, startTime, endTime) {
      let actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.active = active;
      actionData.startTime = startTime || null;
      actionData.endTime = endTime || null;
      actionData.playDate = playDate || null;
      actionData.scheduleId = this.$route.params.id;
      actionData.fromDate = this.scheduleData.startDate;
      actionData.toDate = this.scheduleData.endDate;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    viewDevice(item) {
      if (!item.devices) {
        return [];
      }
      var _devices = this.$helper.convertStringToArray(item.devices, ';\n');
      if (_devices.length <= this.maxDisplayDeviceTable) {
        return _devices;
      }
      return _devices.slice(0, this.maxDisplayDeviceTable);
    },
    addDetailDevice() {
      let that = this;
      if (that.dataDetailDevice.lstDevicesAddSelected != null && that.dataDetailDevice.lstDevicesAddSelected.length > 0) {
        that.dataDetailDevice.loading.value = true;
        this.$helper.loadDataSource({
          url: "/schedule-detail-device/add",
          dataSubmit: function () {
            return {
              devices: that.dataDetailDevice.lstDevicesAddSelected,
              scheduleDetailId: that.dataDetailDevice.scheduleDetailId
            }
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              if (response.data.data.id) {
                that.isShowModelDevicesUpdate = false;
                that.exist.id = response.data.data.id;
                that.exist.msg = response.data.data.msg;
                that.exist.startTime = response.data.data.startTime;
                that.exist.endTime = response.data.data.endTime;
                that.exist.playDate = response.data.data.playDate;
                that.exist.devices = response.data.data.devices;
                that.exist.isShowModelExist = true;
              } else {
                that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
                that.$helper.setupErrorModel(response.data.data, that.$data);
              }
            } else {
              that.showSuccessMsg({message: "Thêm thiết bị thành công"});
              that.dataDetailDevice.lstDevicesAddSelected = [];
              that.dataDetailDevice.lstDevicesRemoveSelected = [];
              that.loadDataMainTable();
              that.loadDataMainDevicesTable();
              that.loadDataMainDevicesScheduleTable();
            }
            that.dataDetailDevice.loading.value = false;
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      } else {
        that.showErrorMsg({message: 'Vui lòng chọn thiết bị'})
      }
    },
    deleteDetailDevice() {
      let that = this;
      if (that.dataDetailDevice.lstDevicesRemoveSelected != null && that.dataDetailDevice.lstDevicesRemoveSelected.length > 0) {
        that.dataDetailDevice.loading.value = true;
        this.$helper.loadDataSource({
          url: "/schedule-detail-device/delete",
          dataSubmit: function () {
            return {
              ids: that.dataDetailDevice.lstDevicesRemoveSelected,
              scheduleDetailId: that.dataDetailDevice.scheduleDetailId
            }
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({message: "Xóa thiết bị thành công"});
              that.dataDetailDevice.lstDevicesAddSelected = [];
              that.dataDetailDevice.lstDevicesRemoveSelected = [];
              that.loadDataMainTable();
              that.loadDataMainDevicesTable();
              that.loadDataMainDevicesScheduleTable();
            }

            that.dataDetailDevice.loading.value = false;
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      } else {
        that.showErrorMsg({message: 'Vui lòng chọn thiết bị'})
      }
    },
  },
  created: function () {
  },
  mounted() {
    this.loadSchedule();
    // this.loadDataDevices();
  },
  watch: {
    "actionData.model.listScheduleDetailSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active')
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    dateRange: function (newValue, oldValue) {
      if ((oldValue.start.getTime() != newValue.start.getTime()) || (oldValue.end.getTime() != newValue.end.getTime())) {
        this.loadDataMainTable();
      } else {
        // this.dateRange = {
        //   start: new Date(),
        //   end: new Date()
        // }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = ''
      this.locationCode.data.model = this.districtCodeInput.data.model;
      if (!this.isFirstLoad) {
        this.loadDataMainTable();
      }
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      if (!this.isFirstLoad) {
        this.loadDataMainTable();
      }
    },
  },
  computed: {},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style lang="scss">
#scheduleDetailList {

  .custom-control-input,
  .override-custom {
    opacity: 0 !important;
  }

  .updateDevice {
    .modal-dialog {
      min-width: 74%;

      .modal-content {
        height: 95vh !important;

        .modal-body {
          overflow-y: auto;
        }
      }
    }
  }

  .info-detail {
    font-weight: 700;
    font-size: 14px;
  }
}
</style>
